import React from "react";
import { Outlet } from "react-router-dom";
import AppFooter from "../Components/AppFooter";
import AppHeader from "../Components/AppHeader";
import { authMenuSinap, noAuthMenuSinap } from "../Utils/constants.api";
import { Loading } from "../Components/LoadingComponent";
import { useSelector } from "react-redux";

export function ParksLayout() {
  const loadingState = useSelector((state) => state.ui.isLoading);
  return (
    <>
      {loadingState && <Loading />}
      <AppHeader
        className=""
        serviceName="Áreas Protegidas (SINAP)"
        preName={"Sistema Nacional de"}
        searchBar={"parque"}
        authMenu={authMenuSinap}
        noAuthMenu={noAuthMenuSinap}
      />
      <div className="main-container">
        <Outlet />
      </div>
      <AppFooter className="" />
    </>
  );
}
